/**
 * I18next interpolation formatter: "{{count, number}}" renders 25000000 as
 * "25,000,000" in en and "25.000.000" in de. Values with unknown formats are
 * stringified, matching plain interpolation.
 */
export function interpolationFormat(
  value: unknown,
  format: string | undefined,
  language: string | undefined
): string {
  if (format === "number" && typeof value === "number") {
    return new Intl.NumberFormat(intlLocale(language)).format(value);
  }
  return String(value);
}

/**
 * The active language may carry a workspace suffix for custom terms (see
 * concatLocaleWithWorkspace), which Intl rejects as a malformed BCP 47 tag.
 * Drop subtags from the right until Intl accepts the tag.
 */
function intlLocale(language: string | undefined): string | undefined {
  if (!language) {
    return undefined;
  }
  const subtags = language.split("-");
  while (subtags.length > 0) {
    const candidate = subtags.join("-");
    if (isWellFormedLocale(candidate)) {
      return candidate;
    }
    subtags.pop();
  }
  return undefined;
}

function isWellFormedLocale(candidate: string): boolean {
  try {
    Intl.NumberFormat.supportedLocalesOf(candidate);
    return true;
  } catch {
    return false;
  }
}
